import React from 'react';

import styles from './flashMessageStyles';

const FlashMessage = ({ children, ...props }) => {
  if (children && typeof children === 'function') {
    return children({ flashMessageStyles: styles.flashMessage });
  }
  return (
    <div className={styles.flashMessage} {...props}>
      {children}
    </div>
  );
};

export default FlashMessage;
